/**
 * Siegel-Verteilung Message Templates
 *
 * Messages für die Siegel-Verteilungsphase nach dem Karten austeilen.
 */

// Spieler hat Siegel zu platzieren
export const HAS_SEALS_NO_SELECTION = [
  'Jetzt wird gesiegelt! Wähle Siegel oder Karte zuerst.',
  'Lasset das Siegeln beginnen! Tippe Siegel → Karte oder Karte → Siegel.',
  'Jetzt Siegel setzen! Und beides geht: erst Siegel klicken oder erst Karte.',
];

export const SEAL_SELECTED = [
  'Tippe auf eine Karte für {sealName}!',
  '{sealName} bereit - wähle eine Karte!',
  'Karte für {sealName} auswählen!',
];

// Karte zuerst ausgewählt
export const CARD_SELECTED = [
  'Karte ausgewählt - jetzt ein Siegel tippen!',
  'Wähle jetzt ein Siegel für diese Karte!',
  'Karte gewählt, tippe auf ein Siegel zum Platzieren!',
];

export const ALL_PLACED = [
  'Alle Siegel platziert. Klicke "Fertig"!',
  'Siegel verteilt - "Fertig" drücken!',
  'Fertig mit den Siegeln? Dann jetzt bestätigen!',
];

// Spieler hat keine Siegel
export const NO_SEALS = [
  'Keine Siegel in deinem Stash! Warte, bis alle fertig sind.',
  'Du hast keine Siegel und musst warten.',
  'Du hast keine Siegel. Warte auf andere Spieler...',
];

// Warten auf andere
export const WAITING_ONE = [
  'Einer trödelt noch rum...',
  'Einer braucht mal wieder ewig...',
  'Puh, einer macht ewig rum!',
];

export const WAITING_MULTIPLE = [
  '{count} Spieler platzieren noch Siegel...',
  'Noch {count} Spieler am Siegeln...',
  '{count} Leute brauchen noch Zeit beim Siegeln.',
];

// Spieler fertig
export const PLAYER_READY = [
  '{name} ist fertig!',
  '{name} hat seine Siegel platziert!',
];

// Alle fertig
export const ALL_READY = [
  'Alle Siegel platziert!',
  'Siegel-Phase abgeschlossen...',
];
